import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function fmtErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export const fileUrl = (u) =>
  !u ? "" : u.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u;

export const DOC_TYPES = [
  { value: "sale_deed", label: "Sale Deed" },
  { value: "khata", label: "Khata Certificate / Extract" },
  { value: "mutation", label: "Mutation Register (MR)" },
  { value: "rtc", label: "RTC (Pahani)" },
  { value: "ec", label: "Encumbrance Certificate (EC)" },
  { value: "tax", label: "Property Tax Receipt" },
  { value: "gift", label: "Gift Deed" },
  { value: "poa", label: "Power of Attorney" },
  { value: "other", label: "Other Document" },
];

export const SEV_STYLES = {
  critical: "bg-red-100 text-red-700 border-red-200",
  high: "bg-red-50 text-red-600 border-red-200",
  medium: "bg-amber-50 text-amber-700 border-amber-200",
  low: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export const RISK_STYLES = {
  Low: "bg-emerald-100 text-emerald-700",
  Medium: "bg-amber-100 text-amber-700",
  High: "bg-red-100 text-red-700",
  Critical: "bg-red-600 text-white",
};
